<template>
  <div>
    <van-nav-bar fixed placeholder left-text="个人资料" left-arrow @click-left="$router.back()">
    </van-nav-bar>
    <ul class="functionlist">
      <li style="margin-top:0;">
        <van-cell title="头像" title-style="text-align:left;">
          <template #right>
            <van-image width="100" height="100" src="https://img.yzcdn.cn/vant/cat.jpeg" />
          </template>
        </van-cell>
        <van-cell title-style="text-align:left;" is-link url="/vant/mobile.html">
          <template #title>
            <span class="custom-title">用户名</span>
          </template>
        </van-cell>
        <van-cell title-style="text-align:left;" is-link to="index">
          <template #title>
            <span class="custom-title">姓名</span>
          </template>
        </van-cell>
        <van-cell title-style="text-align:left;" :value="global.formatDate(user.endDate,'yyyy-MM-dd')">
          <template #title>
            <span class="custom-title">电话</span>
          </template>
        </van-cell>
      </li>
      <li style="margin-top:-15px;">
        <van-cell title-style="text-align:left;" is-link url="/vant/mobile.html">
          <template #title>
            <span class="custom-title">密码设置</span>
          </template>
        </van-cell>
        <van-cell title-style="text-align:left;" is-link url="/vant/mobile.html">
          <template #title>
            <span class="custom-title">电话</span>
          </template>
        </van-cell>
        <van-cell title-style="text-align:left;" is-link @click="logout">
          <template #title>
            <span class="custom-title">微信</span>
          </template>
        </van-cell>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  Col,
  Row,
  Image as VanImage,
  Icon,
  Cell,
  CellGroup,
  Tag,
  NavBar
} from "vant";
import MainMenuNav from "@/components/MainMenuNav.vue";

export default {
  name: "UserInfo",
  components: {
    MainMenuNav,
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar
  },
  data() {
    return {
      user: this.global.getUserInfo(),
      company: this.global.getMemberSystem()
    };
  },
  methods: {
    logout: function() {
      localStorage.clear();
      this.$router.push({ path: "/" });
    }
  }
};
</script>
